module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2021_30.19e4d4d4.jpg";